import type { FC } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Info } from "lucide-react";
import remarkGfm from "remark-gfm";
import { Card } from "@ui/Card";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@ui/Dialog";
import { ScrollArea } from "@ui/ScrollArea";
import { cn } from "@/utils/tailwind";

interface CalculationInfoCardProps {
  className?: string;
}

export const CalculationInfoCard: FC<CalculationInfoCardProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Dialog>
      <DialogTrigger className={cn("w-full text-start", className)}>
        <Card className="bg-background flex w-full! cursor-pointer flex-row items-start gap-2 p-4! text-sm sm:gap-4 sm:text-base">
          <div className="px-px py-1 sm:py-0">
            <Info className="size-[13px] shrink-0 sm:size-6" strokeWidth={1.5} />
          </div>
          <p className="leading-[22.4px] sm:leading-6">
            <span className="underline">{t("clickHere")}</span> {t("learnMore")}
          </p>
        </Card>
      </DialogTrigger>
      <DialogContent className="text-sm lg:text-base">
        <ScrollArea className="h-[70dvh] md:h-[80dvh]">
          <div className="flex flex-col gap-6 pr-2 lg:gap-10">
            <DialogTitle className="pr-4 sm:pr-0">{t("howDoWePerformCalculations")}</DialogTitle>
            <DialogDescription className="hidden" />
            <div className="space-y-4">
              <article className="prose prose-neutral vtac:prose-invert vtac:prose-p:text-muted-foreground max-w-none leading-snug">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {t("howDoWePerformCalculationsDescription")}
                </ReactMarkdown>
              </article>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
